import { SettingConst } from '../../types';

/**
 * Feature setting enabling issue search in help center self-serve flow
 */
export const HELP_CENTER_ISSUE_SEARCH_231018 =
  'HELP_CENTER_ISSUE_SEARCH_231018' as SettingConst<
    'HELP_CENTER_ISSUE_SEARCH_231018',
    boolean,
    'HELP_CENTER' | 'HOTJAR_HELP_CENTER'
  >;
